module.exports = __webpack_public_path__ + "static/media/backWave12.b5de22e7.svg";